'use client';

import { CaretUp } from 'assets/icons';
import { forwardRef } from 'react';
import { Container, CustomImage as Image } from '..';
import { analytics } from 'lib/analytics/analytics';
import CustomLink from 'components/shared/CustomLink';
import styles from './Products.module.css';

const products = [
  // {
  //   imgSrc: 'web_v2/hsa-fsa/products/ring.png',
  //   title: 'Ring AIR',
  //   price: '$349',
  //   description: 'Taxes excl.',
  //   cta: 'Explore',
  //   ctaLink: '/ring/buy/us',
  // },
  {
    imgSrc: 'web_v2/hsa-fsa/products/r-pro.png',
    title: 'Ring PRO',
    price: '$479',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/ring-pro/buy',
  },
  {
    imgSrc: 'web_v2/hsa-fsa/products/m1.png',
    title: 'M1',
    pre: 'Starting at',
    price: '$249',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/pricing',
  },
  {
    imgSrc: 'web_v2/hsa-fsa/products/home-1.png',
    title: 'Home',
    price: '$549',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/home',
  },
  {
    imgSrc: 'web_v2/hsa-fsa/products/photon.png',
    title: 'Photon',
    price: '$249',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/photon/buy',
  },
  {
    imgSrc: 'web_v2/hsa-fsa/products/voyager-2.png',
    title: 'Voyager Ring Charger',
    price: '$45',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/ring/buy/',
    queryParam: {
      ps: 'voyager-charger',
    },
  },
  {
    imgSrc: 'web_v2/hsa-fsa/products/cardio.png',
    title: 'Cardio Adaptability',
    price: '$24',
    pre: '1 Year at ',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/ring/buy',
    queryParam: {
      ps: 'cardio-powerplug',
    },
  },
  // {
  //   imgSrc: 'web_v2/hsa-fsa/products/rare-2.png',
  //   title: 'Rare Ring',
  //   price: '$1,799',
  //   description: 'Taxes excl.',
  //   cta: 'Explore',
  //   ctaLink: '/rare',
  // },
  {
    imgSrc: 'web_v2/hsa-fsa/products/cno-pro.png',
    title: 'Cycle & Ovulation Pro',
    price: '$39.99',
    pre: '1 Year at ',
    description: 'Taxes excl.',
    cta: 'Explore',
    ctaLink: '/ring/buy',
  },
];

const Product = ({
  imgSrc,
  ctaLink,
  title,
  price,
  description,
  cta,
  pre,
  queryParam = {},
}: {
  imgSrc?: string;
  ctaLink: string;
  title: string;
  price: string;
  description: string;
  cta: string;
  pre?: string;
  queryParam?: Record<string, string>;
}) => {
  return (
    <CustomLink
      className={styles.product}
      href={{ pathname: ctaLink, query: queryParam }}
      onClick={() => analytics.track(`explore - HSA/FSA - ${title}`)}
    >
      {imgSrc ? (
        <div className={styles.img}>
          <Image
            src={imgSrc}
            alt="product_img"
            height={448}
            width={300}
            style={{
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
        </div>
      ) : null}
      <div className={styles.info}>
        <div className={styles.spec}>
          <div className={styles.title}>
            {title} <br />
            {pre} {price} <span>{description}</span>
          </div>
          <div className={styles.link}>
            {cta}{' '}
            <CaretUp fill="black" style={{ transform: 'rotate(90deg)' }} />
          </div>
        </div>
      </div>
    </CustomLink>
  );
};

export const ProductSection = forwardRef<HTMLDivElement, { className?: string }>(
  ({ className }, ref) => {
    return (
      <div
        className={className ? `${styles.section} ${className}` : styles.section}
        ref={ref}
      >
        <Container>
          <h4>Shop HSA/FSA eligible products</h4>
          <div className={styles.products}>
            {products.map((product, index) => (
              <Product key={`product-${index}`} {...product} />
            ))}
          </div>
        </Container>
      </div>
    );
  },
);

ProductSection.displayName = 'ProductSection';
